export default {
  form: {
    agreement: {
      label:
        'Potwierdzam, że udzielenie elektronicznej zgody jest równoznaczne z podpisaniem tego dokumentu i rozumiem, że mój podpis elektroniczny jest wiążący.',
    },
    signed_by: {
      label: 'Imię i nazwisko',
      placeholder: 'Imię i nazwisko',
    },
    signer_first_name: {
      label: 'Imię',
      placeholder: 'Imię',
    },
    signer_last_name: {
      label: 'Nazwisko',
      placeholder: 'Nazwisko',
    },
    recipient_email: {
      label: 'Adres e-mail odbiorcy',
      placeholder: 'Wpisz adres e-mail',
    },
    send_to_email: {
      label: 'Wyślij umowę do właściciela e-mailem ({{email}})',
    },
    additional_locations: {
      label: 'Dodatkowe lokalizacje',
      placeholder: 'Wyszukaj lokalizację do dodania',
    },
    special_agreements: {
      label: 'Ustalenia szczególne',
      placeholder: 'Wpisz wszelkie ustalenia szczególne',
    },
  },
  labels: {
    name: 'Imię i nazwisko',
    date: 'Data',
  },
  buttons: {
    sign_in_person: 'Podpisz tutaj z właścicielem',
    back: 'Wstecz',
    edit_contract: 'Edytuj umowę',
    skip: 'Pomiń',
    sign: 'Podpisz',
    init_sign: 'Utwórz umowę i wyślij',
    redo: 'Ponów',
    continue: 'Kontynuuj',
    preview: 'Podgląd',
    submit: 'Zatwierdź',
  },
  toasts: {
    failed_to_preview_contract: 'Nie udało się wyświetlić podglądu umowy',
    contract_signing_pending: 'Chwilę, inicjujemy Twoją umowę…',
    failed_to_sign_contract: 'Nie udało się zainicjować umowy ⁉️',
    contract_got_signed: 'Umowa została zainicjowana 👌',
  },
  in_person_signing: {
    description:
      'Właściciel otrzymał ten link e-mailem i może podpisać zdalnie. Jeśli właściciel jest teraz z Tobą, otwórz tutaj stronę podpisu.',
  },
  signature_link: {
    label: 'Link do podpisu (ten sam link wysłany do odbiorcy e-mailem)',
    copy: 'Kopiuj',
    copied: 'Link do podpisu skopiowany do schowka',
  },
  header: 'Utwórz umowę',
  description: 'Sprawdź szczegóły umowy i podaj adres e-mail, na który ma zostać wysłana.',
};
